import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {FETCH_METRO_AREAS,FETCH_VEHO_ZIPCODES} from "actions/actionTypes";
import InventoryProjectsListTable from "./InventoryProjectsListTable";
var async = require('async');
 import RemoveModalDialog from'shared/RemoveModalDialog';
import {
    makeRequest,
    dispatchAction,
    displayMessage
} from 'actions';


import {Row, Col, Form, FormGroup, Checkbox, Modal, ControlLabel, FormControl, Button} from 'react-bootstrap';
import Select   from 'react-select'

import queryString from 'query-string'
import PaginationBox from'shared/PaginationBox';
 import InventoryProjectsSearchBox from 'dashboard/inventoryProjects/InventoryProjectsSearchBox'

import config from  '../../../config';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";

var screenDataMap = {

    'AddInventoryProjectScreen': {title: 'Start New Inventory Project'},
}


class InventoryProjectsPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);
        this.state = {
            showModal: false,
            currentModal: false,
            currentTab: 'SpotChecks',
            errors: {},
            sortBy: '',
            searchText: '',
            currentRecord: {},

            currentScreen: 'AddInventoryProjectScreen',
            inventoryProjects: {
                data: [],
                fetched: false,
                total: 0
            },
        };
        this.searchBox = null
     };

    componentWillMount() {

    }

    showRemoveDialog(row) {
        this.setState({removeRecordModalVisible: true, currentRecord: row});
    }





    addInventoryProject() {
        this.setState({
            showModal: true,
            currentScreen: 'AddInventoryProjectScreen',
        });
    }

    changeTab(params) {
        this.setState({
            currentTab: params.currentTab,
            inventoryProjects: {
                data: [],
                total: 0,
                fetched: false,
            },
        }, function() {
            this.search( )
        });


    }


    closeModal() {
        this.setState({
            showModal: false,
            currentRecord: {},

        });
    }

    createInventoryProject() {
        var self = this;
        return new Promise((resolve, reject) => {
            this.setState({pending: true});
            var formData = this.validateAndGetFormData();
            if (!formData) {
               return reject()
            }
            var methodData = {
                "endpoint": "/inventory_projects",
                timeout: 70000,
                type: 'post'
            };

            self.props.makeRequest(formData, methodData).then(response => {


                resolve(true)
            }).catch(err => {

                reject(err)
            });
        })
    }
    validateAndGetFormData() {
        var formData = _.pick(this.state.currentRecord, ['MarketName', 'ProjectType' ])

        // if (!formData.StartDate) {
        //     this.props.displayMessage({
        //         'messageType': 'warning',
        //         'messageCode': 'errorFieldNotSpecified',
        //         messageData: {'#1#': 'Start Date'}
        //     })
        //
        //     return false
        // }

            // if (!moment(formData.StartDate, 'MM-DD-YYYY',true).isValid()) {
            //
            //
            //
            //       this.props.displayMessage({
            //         'messageType': 'warning',
            //         'messageCode': 'errorDateIsNotValid',
            //     });
            //     return false
            // }


        return formData
    }

    onSortChange(field, sort) {
        console.log('field', field);
        this.setState({sortBy: field + ':' + (sort == 'asc' ? 1 : -1)}, function () {
            this.refs.pagination.resetPagination();
            this.search()
        })
    }

    search(params = {}) {
        if (this.state.pending){
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Please wait till search request is completed'
            });
        }
        this.setState({pending:true})
         var self = this, queryParams = {}
        if (this.searchBox) {
            var {queryParams} = this.searchBox.getSearchParams();
        }
        _.extend(queryParams, params);
        console.log('queryParams', queryParams  );
        if (!_.get(queryParams,'Markets.0')){
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Please, select a location'
            });
        }
        queryParams.lookup = ['Products']
        var searchData = {}
        if (this.state.currentTab == 'SpotChecks') {
            searchData.ProjectTypes = ['SpotCheck']

        } else if (this.state.currentTab == 'BiAnnualReports') {
            searchData.ProjectTypes = ['BiAnnual']
        } else if (this.state.currentTab == 'MonthlyReports') {
            searchData.ProjectTypes = ['Monthly']

        }else if (this.state.currentTab == 'ScheduledDeliveries') {


        }
         _.extend(queryParams, searchData);

        if (this.state.sortBy) {
            queryParams.sortBy = this.state.sortBy;
        } else {
            queryParams.sortBy = 'StartDate' + ':' + (1);
        }

        queryParams.addFields =  ['InventoryCount']



        var methodData = {
            'endpoint': '/inventory_projects',
            timeout: 25000,

        };
        const stringified = queryString.stringify(_.omit(queryParams, [ 'fieldsToSearch','addFields',  'lookup',  'sortBySecondary']));
        this.context.router.push('/admin/inventory-projects?' + stringified);

        return this.props.makeRequest(queryParams, methodData).then(res => {
            this.setState({pending:false})
            self.setState({
                inventoryProjects: {
                    data: res.data.data,
                    total: res.data.total,
                    fetched: true,
                }
            })
            if (self.refs.pagination && _.isUndefined(queryParams.page)) {
                self.refs.pagination.resetPagination();
            }
        }).catch(err => {
            this.setState({pending:false})
        });


    }
    deleteInventoryProject( ) {
        this.setState({removeRecordModalVisible: false});
        var methodData = {
            type: 'delete',
            "endpoint": "/inventory_projects",
            messageData: {'#1#': 'Inventory project'},
            messageCode: 'recordDeleted',
        };
        this.props.makeRequest({id:this.state.currentRecord._id }, methodData).then(res => {
            this.setState({currentRecord: {}});
            this.search()
        }).catch(err => {
            this.setState({currentRecord: {}});
            console.log('e', err);
        });

    }

    displayCurrentScreenContent() {
    var self = this;
        if (this.state.currentScreen == 'VehoScreen') {
            var productsAddedToPackages =  _.reduce(_.get(this.state.currentRecord,'selectedPackages',[]), function (total, selectedPackage) {
                total += _.get(selectedPackage, 'packageProducts',[]).length

                return total
            }, 0)
            var allAvailableProducts =  _.reduce(_.get(this.state.currentRecord, 'OrderProducts', []), function (total, product) {
                if (_.get( self.searchBox,'state.filterOptions.Market')){
                    if(_.get(product, 'Transaction.MarketName', '') !== _.get( self.searchBox,'state.filterOptions.Market')){
                        return total
                    }
                }
                if (_.get(product, 'Transaction.FulfilledAt')) {
                    return total
                }
                if (_.get(product, 'Transaction.Status') !== 'Pending') {
                    return total
                }
                if (!_.get(product,'Transaction._id')){
                    return total
                }
                return total+1
            }, 0)
            console.log('not equal',_.size(_.get(this.state.currentRecord, 'selectedPackages', [])), productsAddedToPackages );
                console.log('productsAddedToPackages', allAvailableProducts, productsAddedToPackages  );

        }
        if (this.state.currentScreen == 'AddInventoryProjectScreen') {
             return <div>

                <Row>
                 <Col xs={12}  style={{maxWidth: 300}} className="top20">
                     <Select
                         tabIndex="0"
                         clearable={false}
                         placeholder="Location"
                         options={   _.map(config.warehouseData, item => {
                             return {value: item.MarketName, label: item.MarketName}
                         })}
                         onChange={ (option) =>{
                             this.setState({'currentRecord': {...this.state.currentRecord, MarketName:option ? option.value : null}}, function () {

                             });
                         }}

                         value={this.state.currentRecord.MarketName}
                     />
                 </Col>
                    <Col xs={12}  style={{maxWidth: 300}} className="top20">
                        <Select
                            tabIndex="0"
                            placeholder="Type"
                            clearable={false}
                            options={config.inventoryProjectTypes}
                            onChange={ (option) => {
                                this.setState({
                                    'currentRecord': {
                                        ...this.state.currentRecord,
                                        ProjectType: option ? option.value : null
                                    }
                                })
                            }}
                            value={this.state.currentRecord.ProjectType}/>
                    </Col>

                    {/*<Col xs={12}  style={{maxWidth: 300}} className="top20">*/}
                        {/*<Datetime*/}
                            {/*closeOnSelect={true}*/}
                            {/*dateFormat={'MM-DD-YYYY'} timeFormat={false}*/}
                            {/*onChange={(option) => {*/}
                                {/*this.setState({*/}
                                    {/*'currentRecord': {*/}
                                        {/*...this.state.currentRecord,*/}
                                        {/*StartDate: option*/}
                                    {/*}*/}
                                {/*});*/}
                            {/*}}*/}
                            {/*inputProps={{*/}
                                {/*placeholder: 'Start Date',*/}
                            {/*}}*/}
                            {/*value={   this.state.currentRecord.StartDate    }*/}
                        {/*/>*/}
                    {/*</Col>*/}

             </Row>
                <Row className="left0 top30">
                    <Col md={12} sm={12} xs={12} className="pleft0 top20 bot10">
                        <Button className=" right0 pull-right btn btn-primary "
                                type="button"
                                disabled={ this.state.pending || !this.state.currentRecord.ProjectType  || !this.state.currentRecord.MarketName}
                                onClick={ () => {
                                    var self =this
                                    if (!this.state.pending) {
                                        this.createInventoryProject().then(function (response) {
                                            self.search()
                                            self.setState({pending: false});
                                            self.closeModal()
                                        }).catch(err => {
                                            self.setState({pending: false});
                                        })
                                    }
                                }}>Submit
                        </Button>

                        <Button className="pull-left btn btn-default" type="button"
                                onClick={(e) => this.closeModal()}>
                            Cancel
                        </Button>
                    </Col>
                </Row>
            </div>
        }

    }




    render() {
        console.log('page state 1', this.state)
        return (
            <div  >
                <InventoryProjectsSearchBox pending={this.state.pending}
                                            ref={(searchBox) => {
                        if (searchBox && !this.searchBox) {
                            this.searchBox = searchBox;
                            this.search()
                        }
                    } }
                    currentTab={this.state.currentTab}
                    addInventoryProject={this.addInventoryProject.bind(this)}
                    changeTab={this.changeTab.bind(this)}
                    search={this.search.bind(this)}
                    {...this.props} >
                </InventoryProjectsSearchBox>

                <div className="clearfix"></div>
                {this.state.inventoryProjects.fetched &&
                <div className="">
                    {this.state.inventoryProjects.total == 0 ?
                        <div
                            className="messageBox">{config.clientMessages.noRecordsFoundForCriteria.replace("#1#", 'records')}</div> :
                        <div className="top10">
                            {_.includes(['SpotChecks','MonthlyReports','BiAnnualReports'],this.state.currentTab) &&
                            <InventoryProjectsListTable
                                showRemoveDialog ={this.showRemoveDialog.bind(this)}
                                tableData={this.state.inventoryProjects.data}
                                onSortChange={this.onSortChange.bind(this)}
                                changeTab={this.changeTab.bind(this)}
                                currentTab={this.state.currentTab}

                                search={this.search.bind(this)} {...this.props}>
                            </InventoryProjectsListTable>}




                            <PaginationBox
                                currentPage={_.isUndefined(queryString.parse(this.props.location.search).page) ? 0 : parseInt(queryString.parse(this.props.location.search).page) - 1}
                                perPage={this.searchBox ? this.searchBox.state.filterOptions.perPage : _.get(queryString.parse(this.props.location.search), ['perPage'], undefined)}
                                ref={'pagination'}
                                total={  this.state.inventoryProjects.total}
                                search={this.search.bind(this)}>
                            </PaginationBox>
                        </div>}






                </div>
                }
                <RemoveModalDialog
                    show={this.state.removeRecordModalVisible}
                    removeRecord={(e) => this.deleteInventoryProject() }
                    closeModal={(e) => this.setState({currentRecord: false, removeRecordModalVisible: false})}>
                </RemoveModalDialog>
                <Modal onExited={this.closeModal.bind(this)} show={this.state.showModal}
                       onHide={(e) => this.setState({showModal: false})}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{ _.get(screenDataMap, [this.state.currentScreen, 'title'], '') }</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {  !_.includes(['CreateOrderConfirmationScreen', 'AddInventoryProjectScreen'], this.state.currentScreen) && this.displayOrderDataAndProducts()}
                        {this.displayCurrentScreenContent()}
                    </Modal.Body>
                </Modal>
                {this.state.pending &&
                <div className="pending-box"></div>
                }
            </div>
        );
    }
}

function mapStateToProps(state, props) {
    return {
        metroAreas: state.metroAreas,
        vehoZipCodes: state.vehoZipCodes,
        userReducer: state.userReducer,
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, dispatchAction, displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(InventoryProjectsPage);
